import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import {
    SovosBox,
    SovosMenuItem,
    SovosToolbar,
    SovosToolbarActions,
    SovosToolbarMoreMenu,
    SovosTypography,
} from "mosaic-react";
import { Download, PlayArrow } from "mosaic-react-icons";

export default function GeneratorLineMoreActions(props) {
    const { i18n, downloadFile, forceGenerateFile, reload, pushNotification, params } = useGlobalValue();
    const { value: cell } = props || {};
    const { name, entity, id, generationStatus } = cell || {};

    return (
        <SovosBox>
            <SovosToolbar
                sx={{
                    backgroundColor: "transparent !important",
                }}
            >
                <SovosToolbarActions>
                    <SovosToolbarMoreMenu
                        disabled={
                            !["success", "pre_validation_failed", "data_integrity_failed"].includes(
                                generationStatus,
                            )
                        }
                    >
                        {generationStatus === "success" && (
                            <SovosMenuItem
                                onClick={() => {
                                    downloadFile({
                                        fileName: name,
                                        importId: id,
                                        id: `tooltip_${id}`,
                                        entity,
                                        projectId: params?.projectId,
                                    }).catch(() => {
                                        pushNotification({
                                            open: true,
                                            message: i18n`Something went wrong!`,
                                            type: "error",
                                            timeout: "short",
                                        });
                                    });
                                }}
                            >
                                <Download />
                                <SovosTypography children={i18n`Download`} variant={"span"} />
                            </SovosMenuItem>
                        )}
                        {["pre_validation_failed", "data_integrity_failed"].includes(
                            generationStatus,
                        ) && (
                            <SovosMenuItem
                                onClick={() => {
                                    forceGenerateFile({
                                        id,
                                    })
                                        .then(() => {
                                            reload && reload();
                                        })
                                        .catch((e) => {
                                            pushNotification({
                                                open: true,
                                                message: i18n`${e?.message || "Something went wrong!"}`,
                                                type: "error",
                                                timeout: "short",
                                            });
                                        });
                                }}
                            >
                                <PlayArrow />
                                <SovosTypography children={i18n`Generate`} variant={"span"} />
                            </SovosMenuItem>
                        )}
                    </SovosToolbarMoreMenu>
                </SovosToolbarActions>
            </SovosToolbar>
        </SovosBox>
    );
}
